import { render, staticRenderFns } from "./answerExercisesSetUp.vue?vue&type=template&id=4a97a74c&scoped=true&"
import script from "./answerExercisesSetUp.vue?vue&type=script&lang=js&"
export * from "./answerExercisesSetUp.vue?vue&type=script&lang=js&"
import style0 from "./answerExercisesSetUp.vue?vue&type=style&index=0&id=4a97a74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97a74c",
  null
  
)

export default component.exports